<template>
  <el-autocomplete ref="elAutocomplete" clearable @clear="blurForBug()"
                   :fetch-suggestions="querySearch" @select="handleSelect"
                   :placeholder="placeholderkeyword" @keydown.enter.native="searchMbBlur"
                   size="medium" v-model="searchInput" :style="{width: styleWidth + 'px'}">
    <el-button slot="append" type="warning" icon="el-icon-search" @click="searchMbBtn"
               style="font-weight:bold;font-size:17px;color:#000000;">搜尋
    </el-button>
  </el-autocomplete>
</template>

<script>
export default {
  name: 'memoryrecent',
  props: [
    'placeholderkeyword'
  ],
  data: () => {
    return {
      searchHistory: [],
      searchInput: '',
      styleWidth: 540
    }
  },
  mounted () {
    // console.log('memoryrecent.vue' + this.searchInput)
    // 控制輸入框的寬度，電腦版和手機版的輸入框的寬度不能一樣。
    let heightFlag = this._isMobile()
    // 移动
    if (heightFlag) {
      this.styleWidth = 300
    } else {
      this.styleWidth = 540
    }
    // 如果輸入框原來有值就做一下賦值處理  展示記憶功能
    let searchInput = sessionStorage.getItem('searchInput')
    if (searchInput) {
      this.searchInput = searchInput
    }
  },
  methods: {
    searchMbBlur () {
      this.$emit('search-mbBlur', this.searchInput)  // 触发父组件的查询方法 并传递searchInput的值
      this.performSearch()  // 执行搜索方法   点击回车的时候 执行搜索方法
      // 搜索的時候，把下拉列表消失
      this.$refs.elAutocomplete.activated = false
    },
    searchMbBtn () {
      this.$emit('search-mbBtn', this.searchInput)  // 触发父组件的查询方法 并传递searchInput的值
      this.performSearch()  // 执行搜索方法   点击回车的时候 执行搜索方法
      // 搜索的時候，把下拉列表消失
      this.$refs.elAutocomplete.activated = false
    },
    // 增加搜索框可以選擇已經輸入過的文字
    // 执行搜索
    // 点击查询的时候，触发搜索方法，并且把搜索框的内容保存到本地存储中
    performSearch () {
      if (!this.searchInput.trim()) return

      let strs = localStorage.getItem('searchHistory')
      let arrays = JSON.parse(strs)
      if (arrays == null || arrays.length === 0) {
        this.searchHistory = []
      } else {
        this.searchHistory = arrays
      }

      // 去重处理
      const index = this.searchHistory.indexOf(this.searchInput)
      if (index > -1) {
        this.searchHistory.splice(index, 1)
      }

      // 添加到历史记录
      this.searchHistory.unshift(this.searchInput.trim())

      // 限制历史记录数量（最多10条）
      if (this.searchHistory.length > 10) {
        this.searchHistory.pop()
      }

      // 持久化存储
      this.saveToLocalStorage()

      // 执行实际搜索逻辑
      // console.log('执行搜索：', this.searchInput)
    },

    // 保存到本地存储
    saveToLocalStorage () {
      if (this.searchHistory !== []) {
        localStorage.setItem(
          'searchHistory',
          JSON.stringify(this.searchHistory)
        )
      }
    },

    querySearch (queryString, cb) {
      let strs = localStorage.getItem('searchHistory')
      let arrays = JSON.parse(strs)
      if (arrays == null || arrays.length === 0) {
        return cb([])
      }
      let arrayMaps = []
      for (let item of arrays) {
        let map = {}
        map['value'] = item
        arrayMaps.push(map)
      }
      const results = arrayMaps
      // 调用 callback 返回建议列表的数据
      cb(results)
    },

    handleSelect (item) {
      // console.log('选中项:', item) // 选中某项后的处理逻辑
      this.searchInput = item.value
      // 此处要回调父组件的查询方法 并传递searchInput的值
      this.$emit('search-mbBlur', this.searchInput)
    },
    blurForBug () {
      // 方法一
      this.$refs.elAutocomplete.activated = true
      // 方法二
      // document.activeElement.blur()
      // 调用一下父组件的方法。
      this.$emit('clear-parent-method')
    },
    clearSearchInput () {
      this.searchInput = ''
    },
    _isMobile: function () {
      let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
      // console.log(flag)
      if (flag) {
        // 手機
        return true
      } else {
        // 电脑版
        return false
      }
    }
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// memoryrecent.vue?68b515ea